/**
 * @generated SignedSource<<fb0227916f369d0671a9ca9191deee2f>>
 * @relayHash 7daaecef1d36118cfd929ff9699c2f4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 314411a76468c913d7416a912483cfd125d2dfeb085397331322df4852238838

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type LevelUpSettingsQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type LevelUpSettingsQuery$data = {
  readonly jira_projectByIdOrKey: {
    readonly created: AGG$DateTime | null | undefined;
    readonly projectStyle: JiraProjectStyle | null | undefined;
    readonly projectType: JiraProjectType | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"AutomationsSection">;
  };
};
export type LevelUpSettingsQuery = {
  response: LevelUpSettingsQuery$data;
  variables: LevelUpSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectKey"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "created"
},
v3 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v4 = {
  "kind": "ScalarField",
  "name": "projectStyle"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "JiraProject",
          "kind": "LinkedField",
          "name": "jira_projectByIdOrKey",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "AutomationsSection"
            }
          ]
        },
        "action": "THROW",
        "path": "jira_projectByIdOrKey"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LevelUpSettingsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "ScalarField",
            "name": "key"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "314411a76468c913d7416a912483cfd125d2dfeb085397331322df4852238838",
    "metadata": {},
    "name": "LevelUpSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9168c8b7ab80b081bf9b587b2ae20de5";

export default node;
